import { defineComponent as _defineComponent } from 'vue'
import { toastServiceError } from '@/services';
import ScriptService from '@/services/api/ScriptService';
import { useUiStore } from '@/stores';
import { Permission, ScriptModel } from '@/types';
import { computed, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';

const JQUERY_URL = 'https://code.jquery.com/jquery-2.1.3.min.js';
const JQUERY_UI_URL = 'https://code.jquery.com/ui/1.11.2/jquery-ui.min.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScriptDetailPage',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const uiStore = useUiStore();

const script: Ref<ScriptModel | undefined> = ref(undefined);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getScript = async (id: number) => {
    try {
        setLoading(true);
        const { data } = await ScriptService.get<ScriptModel>(id);
        script.value = data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

getScript(Number(route.params.id));

const scripts = computed(() => {
    let scripts = '';

    if (script.value?.includeJquery) {
        const scriptJqueryTag = document.createElement('script');
        scriptJqueryTag.setAttribute('src', JQUERY_URL);
        scripts += scriptJqueryTag.outerHTML + '\n';

        const scriptJqueryUiTag = document.createElement('script');
        scriptJqueryUiTag.setAttribute('src', JQUERY_UI_URL);
        scripts += scriptJqueryUiTag.outerHTML + '\n';
    }

    const scriptUrlTag = document.createElement('script');
    scriptUrlTag.setAttribute('src', script.value?.scriptUrl || '');
    scripts += scriptUrlTag.outerHTML;

    return scripts;
});

const copyToClipboard = () => {
    const textarea = document.createElement('textarea');
    textarea.value = scripts.value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

const __returned__ = { route, uiStore, JQUERY_URL, JQUERY_UI_URL, script, setLoading, getScript, scripts, copyToClipboard, get Permission() { return Permission } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})